<script>
import { api } from "@/state/services";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    available: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      clients: null,
      ids: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.modal;
      },
      set(value) {
        this.$emit("update:modal", value);
      },
    },
  },
  methods: {
    getPendings() {
      this.loading = false;
      this.clients = null;
      this.ids = [];

      api
        .get('limpanome/clients/pendings')
        .then((response) => {
          if (response.data.status == "success") {
            this.clients = response.data.list;
          }
        })
    },
    deselectAll() {
      this.ids = [];
    },
    selectAll() {
      this.ids = this.clients.map(client => client.id);
    },
    payPendings() {
      this.loading = true;

      api
        .post('limpanome/clients/pendings', {
          ids: this.ids
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.loading = false;
            this.clients = null;
            this.ids = [];
            this.show = false;

            this.$toast.success("O pagamento foi realizado com sucesso!");

            this.$emit('paid');
          } else {
            this.loading = false;
            this.$toast.error(response.data.message);
          }
        })
        .catch((error) => {
          if (error) {
            this.loading = false;
            this.$toast.error("Erro ao realizar pagamento, tente novamente.");
          }
        });
    },
  },
};
</script>

<template>
  <b-modal v-model="show" title="Pagar" modal-class="modal-right" hide-footer @show="getPendings">
    <b-form @submit.prevent="payPendings">
      <div v-if="!clients" class="text-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="clients && clients.length == 0">
        <div class="text-center">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-15h2v6h-2zm0 8h2v2h-2z"></path>
            </svg>
          </div>
          <div class="mb-3">Nenhum cliente pendente para pagamento.</div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex flex-gap-10 mb-3">
          <div class="flex-fill">
            <div class="bg-light rounded p-3 text-center">
              <h5 class="mt-1 mb-0">{{ available }}</h5>
              <div class="mb-0 font-size-12 text-uppercase">Disponível</div>
            </div>
          </div>
          <div class="flex-fill">
            <div class="bg-light rounded p-3 text-center">
              <h5 class="mt-1 mb-0">{{ clients.length }}</h5>
              <div class="mb-0 font-size-12 text-uppercase">Pendentes</div>
            </div>
          </div>
          <div class="flex-fill">
            <div class="bg-light rounded p-3 text-center">
              <h5 class="mt-1 mb-0">{{ ids.length }}</h5>
              <div class="mb-0 font-size-12 text-uppercase">Selecionados</div>
            </div>
          </div>
        </div>

        <div style="max-height: 40vh; overflow-y: auto;" class="border rounded p-3">
          <b-form-checkbox v-for="client of clients" :key="client.id" v-model="ids" :value="client.id" class="pendings-client bg-soft-light rounded mb-2" style="line-height: 15px;"
            v-bind:class="{ 'client-selected': ids.includes(client.id) }">
            <div>{{ client.name }}</div>
            <div class="text-muted">{{ client.person_number }}</div>
          </b-form-checkbox>
        </div>
        <div class="mt-3 d-flex flex-gap-10">
          <div class="flex-fill w-50">
            <button type="button" class="btn btn-secondary btn-block" v-on:click="deselectAll()">Desselecionar</button>
          </div>
          <div class="flex-fill w-50">
            <button type="button" class="btn btn-secondary btn-block" v-on:click="selectAll()">Todos</button>
          </div>
        </div>
        <b-button class="mt-5 btn-lg btn-block" :disabled="ids.length == 0 || ids.length > available || loading" type="submit"
          variant="success">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path
              d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
            </path>
            <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
          </svg>
          Realizar Pagamento
          <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>

<style>
.pendings-client {
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 10px !important;
}

.pendings-client * {
  cursor: pointer !important;
}

.pendings-client .custom-control-label:before {
  top: 20px;
  left: 16px;
  width: 20px;
  height: 20px;
}

.pendings-client .custom-control-label:after {
  top: 20px;
  left: 16px;
  width: 20px;
  height: 20px;
}

.pendings-client .custom-control-label {
  padding: 15px 15px 15px 50px;
  width: 100%;
}

.pendings-client.client-selected {
  background-color: #bdf4d5 !important;
}
.pendings-client.client-selected .custom-control-input:checked~.custom-control-label::before {
  border-color: #34C391 !important;
  background-color: #34C391 !important;
}
</style>
